import React from 'react';
import { Stack, useDevice, Text, Viewport } from '@treatwell/ui';
import styles from './SectionHeader.module.css';

type SectionHeaderProps = {
  title: string;
  description: string;
  align?: 'start' | 'center';
};

export const SectionHeader = ({
  title,
  description,
  align = 'center',
}: SectionHeaderProps) => {
  const { isMobile, isDesktop } = useDevice();
  return (
    <Stack as="header" align={align} space="base" className={styles.text}>
      <Viewport device={['mobile', 'tablet']} serverRender={isMobile}>
        <Text as="h2" type="xlHeader">
          {title}
        </Text>
        <Text as="p" type="lgHeaderRegular">
          {description}
        </Text>
      </Viewport>
      <Viewport device="desktop" serverRender={isDesktop}>
        <Text as="h2" type="mdHero">
          {title}
        </Text>
        <Text as="p" type="smHeroRegular">
          {description}
        </Text>
      </Viewport>
    </Stack>
  );
};
